import { Reorder } from 'framer-motion';
import { PageCard } from './PageCard.jsx';
import { usePdf } from '../store/pdfStore.js';
import { useT } from '../i18n/index.js';

export function PageGrid({ doc, gridSize, scale }) {
  const t = useT();
  const pages = usePdf((s) => s.pages);
  const selected = usePdf((s) => s.selected);
  const reorder = usePdf((s) => s.reorder);
  const toggleSelect = usePdf((s) => s.toggleSelect);
  const openPage = usePdf((s) => s.openPage);
  const rotatePage = usePdf((s) => s.rotatePage);
  const deletePage = usePdf((s) => s.deletePage);
  const duplicatePage = usePdf((s) => s.duplicatePage);

  if (!pages.length) {
    return <div className="empty">{t('editor.no_pages')}</div>;
  }

  return (
    <Reorder.Group axis="y" values={pages} onReorder={reorder} className={`grid ${gridSize}`} as="div" layoutScroll>
      {pages.map((p, i) => (
        <PageCard
          key={p.id}
          page={p}
          index={i}
          selected={selected.has(p.id)}
          doc={doc}
          scale={scale}
          onSelect={toggleSelect}
          onOpen={openPage}
          onRotate={rotatePage}
          onDelete={deletePage}
          onDuplicate={duplicatePage}
        />
      ))}
    </Reorder.Group>
  );
}
